const societes = "/societes";
const company = "/company";

const routes = {
  home: "/",
  societes: {
    root: societes,
    nouvelle: societes + "/nouvelle",
  },
  company: {
    root: company,
    documents: company + "/documents",
    new: company + "/new",
  },
  procedures: "/procedures",
  emails: "/emails",
  liasse: "/liasse",
  transactions: "/transactions",
  tresorerie: "/tresorerie",
  financement: "/solutions-financement",
  etude: "/etude",
  settings: "/settings",
  account: "/login", // to be refactored everywhere into /account
  confirmEmail: "/account/confirm",
  forgotPassword: "/forgot-password",
  resetPassword: "/account/password/reset",
  invitation: "/invitation",
  createAccount: "/create-account",
};

export default routes;
